import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import Button from '@mui/material/Button';

import Loading from 'uI/Loading/Loading';

import { getMyAcademies } from 'store/campus-actions';

import classes from './MyAcademies.module.css';

const MyAcademies = () => {
  const [academies, setAcademies] = useState([]);
  const [load, setLoad] = useState(true);

  useEffect(() => {
    (async () => {
      setAcademies(await getMyAcademies());
      setLoad(false);
    })();
  }, []);

  return (
    <>
      {!load ? (
        <>
          <p className={classes.title}>Mis Academias</p>
          <div className={classes.academiesContainer}>
            <ul className={classes.listAcademies}>
              {academies.map(academy => (
                <li
                  key={academy.idEmisor}
                  className={classes.academyContainer}
                >
                  <Button
                    component={Link}
                    to={`/academy/${academy.shortName}`}
                    className={classes.academyCard}
                  >
                    <span className={classes.academyName}>
                      Academia: {academy.name}
                    </span>
                    <figure className={classes.academyImg}>
                      <img
                        className={classes.img}
                        src={academy.image}
                        alt={academy.shortName}
                      />
                    </figure>
                    <span className={classes.academyDescription}>
                      {academy.description}
                    </span>
                  </Button>
                </li>
              ))}
            </ul>
          </div>
        </>
      ) : (
        <Loading />
      )}
    </>
  );
};

export default MyAcademies;
